var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 1.33398C4.32659 1.33398 1.33325 4.32732 1.33325 8.00065C1.33325 11.674 4.32659 14.6673 7.99992 14.6673C11.6733 14.6673 14.6666 11.674 14.6666 8.00065C14.6666 4.32732 11.6733 1.33398 7.99992 1.33398ZM11.1866 6.46732L7.40659 10.2473C7.31325 10.3407 7.18659 10.394 7.05325 10.394C6.91992 10.394 6.79325 10.3407 6.69992 10.2473L4.81325 8.36065C4.61992 8.16732 4.61992 7.84732 4.81325 7.65398C5.00659 7.46065 5.32659 7.46065 5.51992 7.65398L7.05325 9.18732L10.4799 5.76065C10.6733 5.56732 10.9933 5.56732 11.1866 5.76065C11.3799 5.95398 11.3799 6.26732 11.1866 6.46732Z",
    fill: "#1A427D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.82e2e6af79547351496277198dc5db24.svg";
export { ForwardRef as ReactComponent };